export { default as Component } from "./Box.svelte";
export const modes = ["static"];
